import { useEffect, useState } from "react";
import { Download } from "lucide-react";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const InstallPWA = () => {
  const [deferred, setDeferred] = useState(null);
  const [hidden, setHidden] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => {
      setDeferred(null);
      setHidden(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (hidden || !deferred) return null;

  const install = async () => {
    deferred.prompt();
    try {
      await deferred.userChoice;
    } finally {
      setDeferred(null);
    }
  };

  return (
    <button
      type="button"
      onClick={install}
      data-testid="install-pwa-button"
      title="Install DAA Project Management as a desktop app"
      className="hidden sm:flex items-center gap-1.5 h-9 px-3 rounded-md border border-border text-xs font-medium text-foreground hover:bg-accent transition-colors duration-150"
    >
      <Download className="h-3.5 w-3.5" />
      <span>Install app</span>
    </button>
  );
};
